/**
 * A container for one subject. Optional header with title, description and actions.
 * `featured` gives the larger radius reserved for highlighted surfaces.
 */
const Card = ({ title, description, actions, featured = false, as: Element = 'section', children }) => {
  const classes = ['comp-card'];
  if (featured) {
    classes.push('comp-card--featured');
  }
  const hasHeader = title || description || actions;

  return (
    <Element className={classes.join(' ')}>
      {hasHeader && (
        <header className="comp-card__header">
          <div className="comp-card__heading">
            {title && <h3 className="comp-card__title">{title}</h3>}
            {description && <p className="comp-card__description">{description}</p>}
          </div>
          {actions && <div className="comp-card__actions">{actions}</div>}
        </header>
      )}
      {children && <div className="comp-card__body">{children}</div>}
    </Element>
  );
};

export default Card;
